import { render } from "./AddVirtualWallet.vue?vue&type=template&id=c385e60e&scoped=true"
import script from "./AddVirtualWallet.vue?vue&type=script&lang=js"
export * from "./AddVirtualWallet.vue?vue&type=script&lang=js"

import "./AddVirtualWallet.vue?vue&type=style&index=0&id=c385e60e&lang=less&scoped=true"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\记录\\2508幸运28\\xingyun_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c385e60e"]])

export default __exports__